import { cva, type VariantProps } from 'class-variance-authority';
import { uiMarker, uiMarkerLayout } from './shared';

/**
 * RATE FORMULA CARD
 *
 * The two explainer panels above the pricing matrix — "Calls" and "Impounds"
 * — each a tinted icon, a title, and the formula the charge is built from
 * with a coloured bullet in front of it. The bullet is the card's tone, so the
 * legend reads the same colour as the tile beside the title.
 */
export const rateFormulaCardRecipe = cva([
  uiMarker,
  uiMarkerLayout,
  'flex flex-col gap-3 rounded-lg border border-border bg-muted/30 p-4',
]);

/** The bullet in front of the formula. */
export const rateFormulaBulletRecipe = cva(
  [uiMarker, 'size-1.5 shrink-0 rounded-full'],
  {
    variants: {
      tone: {
        neutral: 'bg-muted-foreground',
        primary: 'bg-primary',
        success: 'bg-success',
        warning: 'bg-warning',
        info: 'bg-info',
        destructive: 'bg-destructive',
      },
    },
    defaultVariants: { tone: 'neutral' },
  }
);

export type RateFormulaBulletRecipeProps = VariantProps<
  typeof rateFormulaBulletRecipe
>;
